module.exports = __webpack_public_path__ + "media/images/lb/795-5d9e36bb3862d4a0441254ab3e111614.svg";